import update from 'immutability-helper';

import { Article, RequiredArticle } from '../../../../interfaces/Article';
import { Configuration } from '../../../../interfaces/Configuration';
import { Slot } from '../../../../interfaces/Slot';
import { transferChildren } from './transferChildren';

export const replaceArticleInConfiguration = async (
  configuration: Configuration,
  articleId: string,
  newArticle: Article,
  newSlots: Slot[],
  newRequiredConnectArticle?: RequiredArticle,
): Promise<Configuration> => {
  let oldArticle = configuration.getArticle(articleId);
  if (!oldArticle) {
    oldArticle = configuration?.getAllArticles().find((art) => art.id === articleId) as Article;
  }

  configuration = await transferChildren(configuration, oldArticle, newArticle, newSlots);

  const articles = configuration.articles.map((article) => {
    return article.id === oldArticle.id ? newArticle : article;
  });

  const requiredConnectArticles = configuration.requiredConnectArticles?.filter(
    (requiredConnectArticle) => oldArticle.requiredConnectArticleId !== requiredConnectArticle.id,
  );

  if (newRequiredConnectArticle) {
    requiredConnectArticles.push(newRequiredConnectArticle);
  }

  const requiredLightingArticles = oldArticle.requiredLightingArticlesIds
    ? configuration.requiredLightingArticles?.filter(
        (requiredLightingArticle) =>
          !oldArticle.requiredLightingArticlesIds.includes(requiredLightingArticle.id),
      )
    : [];

  return update(configuration, {
    root: {
      $set: oldArticle.id === configuration.root ? newArticle.id : configuration.root,
    },
    articles: {
      $set: articles,
    },
    requiredConnectArticles: {
      $set: requiredConnectArticles,
    },
    requiredLightingArticles: {
      $set: requiredLightingArticles,
    },
  });
};
